module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/152/assets/images/bfec151e11d8a715fc38f4b3c4755a71.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_arrow.svg
// module id = vXyf
// module chunks = 1